import { html } from '../lib/html.js';
import { icon } from '../lib/icons.js';
import { topbar, brandMark } from '../components/chrome.js';
import notes from '../release-notes.js';

const VERSION = typeof __BG_VERSION__ !== 'undefined' ? __BG_VERSION__ : 'dev';

export default async function about() {
  const commit = (window.__BG__ && window.__BG__.commit) || '';
  return {
    title: 'About',
    html: html`<div class="about">
      ${topbar({ back: '/settings', title: 'About' })}
      <header class="wrap page-head about__head">
        ${brandMark(56)}
        <h1 class="h1">About this app</h1>
        <p class="lede">A calm, complete way to understand the Bhagavad Gita, from the first verse to the last.</p>
      </header>
      <div class="wrap prose about__body">
        <section class="section" aria-labelledby="how-title">
          <h2 class="h3" id="how-title">How it works</h2>
          <p>The Gita's 18 chapters and 700 verses are taught in 87 short lessons, each covering a few verses in order. A lesson shows each verse in clear English with an explanation of what it means (the original Sanskrit is one tap away), asks two or three questions to check the ideas landed, and invites a moment of reflection. It takes about ten minutes. Four optional background lessons set the scene for newcomers.</p>
          <p><a class="text-link" href="/guide">How it works</a> explains it all in a minute, including how to find your way around.</p>
        </section>
        <section class="section" aria-labelledby="src-title">
          <h2 class="h3" id="src-title">The text and translation</h2>
          <p>The Sanskrit text is the standard 700-verse version, taken from Sanskrit Wikisource (public domain). The transliteration follows the IAST convention.</p>
          <p>The English translations, explanations, lessons and notes were written for this app, aiming to be faithful to the Sanskrit and readable by someone meeting the Gita for the first time. Where the great traditions of interpretation disagree about a verse, the app says so rather than choosing a side.</p>
        </section>
        <section class="section" aria-labelledby="priv-title">
          <h2 class="h3" id="priv-title">Privacy</h2>
          <p>There are no ads, no analytics and no tracking. Your progress and notes are stored on your device. If you sign in, a copy is kept in your account so it can sync to your other devices. The server stores your email address, your first name (if you give one) and your progress. Your email is used only to send you sign-in codes, never for newsletters, and there is no password to leak. You can export or delete everything from Settings.</p>
        </section>
        <section class="section" aria-labelledby="new-title">
          <h2 class="h3" id="new-title">What's new</h2>
          ${notes.map((n) => html`<article class="release">
            <p class="release__head"><span class="badge badge--accent">v${n.version}</span><span class="small muted">${new Date(`${n.date}T12:00:00`).toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' })}</span></p>
            <h3 class="release__title">${n.title}</h3>
            <ul class="release__list">${n.notes.map((x) => html`<li>${x}</li>`)}</ul>
          </article>`)}
        </section>
        <section class="section" aria-labelledby="credits-title">
          <h2 class="h3" id="credits-title">Credits</h2>
          <p class="small muted">Type set in Fraunces, Inter and Tiro Devanagari Sanskrit (SIL Open Font License). Icons from Lucide (ISC License).</p>
        </section>
        <p class="tiny muted about__version">${icon('info', { size: 14 })} Version ${VERSION}${commit ? ` · build ${commit.slice(0, 7)}` : ''}</p>
      </div>
    </div>`,
  };
}
